import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "mb-3 article-block" }
const _hoisted_2 = { class: "p-4" }
const _hoisted_3 = { class: "artist-card-img-wrap" }
const _hoisted_4 = ["src"]
const _hoisted_5 = { class: "album-intro-card" }
const _hoisted_6 = { class: "artist-name" }
const _hoisted_7 = { class: "rocknuts-title" }
const _hoisted_8 = { class: "auther-title" }
const _hoisted_9 = { key: 0 }
const _hoisted_10 = ["href"]
const _hoisted_11 = { class: "publish-time" }
const _hoisted_12 = { key: 0 }
const _hoisted_13 = { class: "style-list" }
const _hoisted_14 = { class: "badge badge-primary mb-2" }
const _hoisted_15 = {
  key: 0,
  class: "ml-2 hot-info-item"
}
const _hoisted_16 = /*#__PURE__*/_createElementVNode("span", { class: "iconfont icon-read text-gray" }, null, -1)
const _hoisted_17 = { class: "" }
const _hoisted_18 = { class: "read-more" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_RouterLink = _resolveComponent("RouterLink")!
  const _component_UserTag = _resolveComponent("UserTag")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", null, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createVNode(_component_RouterLink, {
            to: { name:'Musicall',params:{article_id:_ctx.article._id}}
          }, {
            default: _withCtx(() => [
              _createElementVNode("img", {
                class: "card-img",
                src: _ctx.article.primary_img,
                alt: "artist image"
              }, null, 8, _hoisted_4)
            ]),
            _: 1
          }, 8, ["to"])
        ])
      ])
    ]),
    _createElementVNode("div", null, [
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("div", _hoisted_6, [
          _createVNode(_component_RouterLink, {
            to: { name:'Musicall',params:{article_id:_ctx.article._id}}
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.article.title), 1)
            ]),
            _: 1
          }, 8, ["to"])
        ]),
        _createElementVNode("div", _hoisted_7, [
          _createElementVNode("div", _hoisted_8, [
            _createTextVNode(" BY "),
            (_ctx.article.auther)
              ? (_openBlock(), _createElementBlock("span", _hoisted_9, "原作者 " + _toDisplayString(_ctx.article.auther), 1))
              : _createCommentVNode("", true),
            (_ctx.article.url)
              ? (_openBlock(), _createElementBlock("a", {
                  key: 1,
                  href: _ctx.article.url,
                  target: "_blank"
                }, _toDisplayString(_ctx.article.url), 9, _hoisted_10))
              : _createCommentVNode("", true),
            _createVNode(_component_UserTag, {
              user: _ctx.article.user_created,
              full: 1
            }, null, 8, ["user"]),
            _createElementVNode("span", _hoisted_11, [
              _createTextVNode(" [ " + _toDisplayString(_ctx.formatTS(_ctx.article.ts_updated)) + " ", 1),
              (_ctx.article.ts_updated!=_ctx.article.ts_published)
                ? (_openBlock(), _createElementBlock("span", _hoisted_12, "/ " + _toDisplayString(_ctx.formatTS(_ctx.article.ts_published)), 1))
                : _createCommentVNode("", true),
              _createTextVNode(" ] ")
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_13, [
          _createElementVNode("span", _hoisted_14, _toDisplayString(_ctx.article.type.name), 1),
          _createElementVNode("span", {
            class: _normalizeClass(["badge badge-danger mb-2", {'badge-danger':_ctx.article.is_orig.index!=1,'badge-success':_ctx.article.is_orig.index==1}])
          }, _toDisplayString(_ctx.article.is_orig.name), 3),
          (_ctx.article.counter_view>0)
            ? (_openBlock(), _createElementBlock("span", _hoisted_15, [
                _hoisted_16,
                _createTextVNode(" " + _toDisplayString(_ctx.article.counter_view), 1)
              ]))
            : _createCommentVNode("", true)
        ]),
        _createElementVNode("div", _hoisted_17, _toDisplayString(_ctx.article.content.substr(0,20)), 1),
        _createElementVNode("div", _hoisted_18, [
          _createVNode(_component_RouterLink, {
            to: { name:'Musicall',params:{article_id:_ctx.article._id}}
          }, {
            default: _withCtx(() => [
              _createTextVNode(" Read More ")
            ]),
            _: 1
          }, 8, ["to"])
        ])
      ])
    ])
  ]))
}